import { render, staticRenderFns } from "./VillageSeasonSales.vue?vue&type=template&id=a809a7f0&scoped=true&"
import script from "./VillageSeasonSales.vue?vue&type=script&lang=js&"
export * from "./VillageSeasonSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a809a7f0",
  null
  
)

export default component.exports